<template>
  <input
    @input="$emit('input', $event.target.value)"
    :value="value"
    type="search"
    class="hm-search-input"
    placeholder="Search"
  />
</template>

<script>
export default {
  name: 'HMSearch',
  props: {
    value: [String, Number],
  },
}
</script>

<style scoped>
.hm-search-input {
  width: min(100%, 300px);
  height: 38px;
  padding: 13px 30px 13px 17px;
  border-radius: 38px;
  border: 1px solid #d3d3d3;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
  color: #000;
  background-image: url("~@/assets/img/filter-search-icon.svg");
  background-repeat: no-repeat;
  background-position: right 15px center;
  font-family: 'CoreSansCR', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;

  &::placeholder {
    color: #707070;
  }
}
</style>